import * as TypeGraphQL from "type-graphql";
export var DeadLetterSeverity;
(function (DeadLetterSeverity) {
    DeadLetterSeverity["LOW"] = "LOW";
    DeadLetterSeverity["MEDIUM"] = "MEDIUM";
    DeadLetterSeverity["HIGH"] = "HIGH";
    DeadLetterSeverity["CRITICAL"] = "CRITICAL";
})(DeadLetterSeverity || (DeadLetterSeverity = {}));
TypeGraphQL.registerEnumType(DeadLetterSeverity, {
    name: "DeadLetterSeverity",
    description: undefined,
});
//# sourceMappingURL=DeadLetterSeverity.js.map